export const IMAGE_CONTEXTS = {
  BLOG_CONTENT: 'blog-content',
  BLOG_HERO: 'blog-hero',
  BLOG_CARD: 'blog-card',
  RELATED_POSTS: 'related-posts',
  AUTHOR_AVATAR: 'author-avatar'
} as const;

export const RESPONSIVE_BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
  wide: 1600
} as const;

// Note: IMAGE_QUALITY_SETTINGS and MAX_IMAGE_DIMENSIONS have been moved to
// getRecommendedImageProps() and getContextDimensions() functions in
// @/utils/imageOptimization to work WITH Next.js optimization instead of against it.
// 
// This eliminates the double optimization conflicts that were causing 4.7s render delays.
// See: src/utils/IMAGE_OPTIMIZATION_GUIDE.md for migration details. 